exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tableCard {\n    margin: 16px 24px !important;\n}\n\n.pageTitle {\n    line-height: 42px !important;\n    margin: 16px !important;\n}\n\n.headerContainer {\n    margin: 0 24px !important;\n}\n\n.searchField > div {\n    height: 53px;\n}", ""]);

